import { SHORTHAND_STYLE_PROPS } from '../../constants/props';

const {
  align,
  alignSelf,
  bg,
  border,
  borderBottom,
  borderLeft,
  borderTop,
  borderRadius,
  borderRight,
  boxShadow,
  color,
  flexDirection,
  flexWrap,
  display,
  flex,
  h,
  justify,
  justifySelf,
  m,
  mb,
  ml,
  mr,
  mt,
  mx,
  my,
  maxH,
  maxW,
  minH,
  minW,
  overflowX,
  overflowY,
  p,
  pb,
  pl,
  pr,
  pt,
  px,
  py,
  position,
  w,
} = SHORTHAND_STYLE_PROPS;

export const elementShorthandPropsMapping = {
  alignItems: [align],
  alignSelf: [alignSelf],
  backgroundColor: [bg],
  border: [border],
  borderBottom: [borderBottom, border],
  borderLeft: [borderLeft, border],
  borderTop: [borderTop, border],
  borderRadius: [borderRadius],
  borderRight: [borderRight, border],
  boxShadow: [boxShadow],
  color: [color],
  display: [display],
  flex: [flex],
  flexDirection: [flexDirection],
  flexWrap: [flexWrap],
  height: [h],
  justifyContent: [justify],
  justifySelf: [justifySelf],
  margin: [m],
  marginBottom: [mb, my, m],
  marginLeft: [ml, mx, m],
  marginRight: [mr, mx, m],
  marginTop: [mt, my, m],
  maxHeight: [maxH],
  maxWidth: [maxW],
  minHeight: [minH],
  minWidth: [minW],
  overflowX: [overflowX],
  overflowY: [overflowY],
  padding: [p],
  paddingBottom: [pb, py, p],
  paddingLeft: [pl, px, p],
  paddingRight: [pr, px, p],
  paddingTop: [pt, py, p],
  position: [position],
  width: [w],
};
